import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class PartQuantity extends Component {
  constructor(props) {
    super(props);
    this.handlePartQuantityChange = this.handlePartQuantityChange.bind(this);
  }

  handlePartQuantityChange(event, data) {
    const {index} = this.props;
    this.props.editProviderManualOrderElementQuantity(index, parseInt(data.value, 10));
  }

  render() {
    const {partQuantity} = this.props;

    return (
      <Input required
        className='input-part-quantity'
        size='mini'
        name='partQuantity'
        type='number'
        min={1}
        max={99999}
        value={partQuantity}
        placeholder='Cant.'
        onChange={this.handlePartQuantityChange}
      />
    );
  }
}

const {
  editProviderManualOrderElementQuantity,
} = Actions;

export default connect(null, {
  editProviderManualOrderElementQuantity,
})(PartQuantity);
